import React from "react";
import Router from "./Router/router";
import { BrowserRouter } from "react-router-dom";
import { AuthContextProvider } from "./context/AuthContext/AuthContext";

function App() {
  return (
    <div className="App">
      <AuthContextProvider>
        <BrowserRouter>
          <Router />
        </BrowserRouter>
      </AuthContextProvider>
    </div>
  );
}

export default App;